import React, {
    useContext, useMemo 
} from 'react';
import QuoteScreen from './quote';
import {
    DiagnosticFormContext 
} from '../../../../contexts/form';

const GOAL_DATA = {
    health: {
        quote: 'Sunnyside has definitely played a big role in helping me stay on track with my health goals. Glad to stick with something that actually works!',
        user: 'Jon',
        duration: 3
    },
    healthspan: {
        quote: 'This app has changed my life. I have been telling everyone about it!',
        user: 'Therese',
        duration: 2
    },
    weight: {
        quote: 'I just wanted to tell you how grateful I am for sunnyside. I\'ve lost weight, I\'m sleeping better, and my self esteem is higher because I\'ve cut back on alcohol! Thank you!',
        user: 'Diane',
        duration: 2
    },
    sleep: {
        quote: 'I feel absolutely amazing. Sleeping better and my body and mind are thanking me for it!',
        user: 'Shanti',
        duration: 1
    },
    hangover: {
        quote: 'It\'s been such an amazing adjustment. The simple act of tracking has been a game changer. I having been waking up without hangovers and it instantly kick starts my day in a healthy way.',
        user: 'Adam',
        duration: 1
    },
    blackout: {
        quote: 'I had a block party yesterday on my block and tracked every drink and did not blackout and had a great time. That has been my goal all along. Thank you so much for developing this.',
        user: 'Susan',
        duration: 2
    },
    money: {
        quote: 'I\'m just happy to be cutting back as much as I am, saving money and calories and brain cells. I love this service, thank you for doing what you do!',
        user: 'Lisa',
        duration: 2
    },
    emotions: {
        quote: 'Last night, after a horrible day, I went home with the intention of drinking the pain away. I stopped after two small glasses of wine and instead let myself feel all the feels. Thank you for helping me to hold myself accountable. I really appreciate it!',
        user: 'Susan',
        duration: 2
    },
    stress: {
        quote: 'I actually have been feeling pretty good this week. It\'s been a pretty hectic and crazy work week, and before trying to cut back I would unwind after work with several drinks, never counting them. I haven\'t drank away my stress once this week!',
        user: 'Kaitlyn',
        duration: 4
    },
    relationships: {
        quote: 'I feel a whole lot better, my family relationships have dramatically improved, and I\'m much more accomplished overall.',
        user: 'Becca',
        duration: 2
    },
};

export const GoalsQuote = (): JSX.Element => {
    const formContext = useContext(DiagnosticFormContext);
    const topGoalAnswer = useMemo(() => {
        return formContext.answers?.['top_goal'];
    }, [formContext.answers]);
    const backJump = useMemo(() => {
        const endGoal = formContext.answers?.endGoal;

        switch (endGoal) {
        case 'Drink Less':
            return 3;
        case 'Complete Zero':
            return 2;
        default:
            return 1;
        }
    }, [formContext.answers?.endGoal]);

    return (
        <QuoteScreen
            sectionKey={'goals'}
            title={'You\'ve taken the first step'}
            subtitle={'We\'ve helped over 300,000 people reach their healthier drinking goals. You\'re next!'}
            quote={(GOAL_DATA[topGoalAnswer] || GOAL_DATA.health).quote}
            user={(GOAL_DATA[topGoalAnswer] || GOAL_DATA.health).user}
            duration={(GOAL_DATA[topGoalAnswer] || GOAL_DATA.health).duration}
            backJump={backJump}

        />
    );
};

export default GoalsQuote;
